import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root' // This ensures the service is provided as a singleton.
})
export class SpinnerService {
  private requestQueue: string[] = []; // Store request keys as strings for now

  constructor(private ngxSpinnerService: NgxSpinnerService) { }

  /**
   * Add a request to the queue. This could be used to show the spinner.
   * @param key A unique identifier for the request.
   */
  public addRequest(key: string): void {
    // Only add if the request key is not already in the queue
    if (!this.requestQueue.includes(key)) {
      this.requestQueue.push(key);
    }
    this.updateSpinnerState();
  }

  /**
   * Remove a request from the queue. This could be used to hide the spinner.
   * @param key A unique identifier for the request.
   */
  public popRequest(key: string): void {
    const index = this.requestQueue.indexOf(key);
    if (index > -1) {
      this.requestQueue.splice(index, 1); // Remove the request from the queue
    }
    this.updateSpinnerState();
  }

  /**
   * Update the spinner's visibility based on whether there are any pending requests.
   * If the request queue is empty, hide the spinner. Otherwise, show it.
   */
  private updateSpinnerState(): void {
    if (this.requestQueue.length > 0) {
      // Show the spinner
      this.ngxSpinnerService.show();
    } else {
      // Hide the spinner
      this.ngxSpinnerService.hide();
    }
  }
}
